// src/pages/AboutUs.js
import React from 'react';
import { motion } from 'framer-motion';
import './AboutUs.css';
import { Helmet } from 'react-helmet';

const AboutUs = () => {
  const teamData = [
    {
      title: 'Managing Director',
      name: 'Mr. Udai Singh',
      image: '/images/udai-singh.jpg',
      description: 'Drives operations and ensures engineering excellence.',
    },
  ];

  return (
    <section id="about" className="about-section" aria-labelledby="about-heading">
      <Helmet>
        <title>About Us | UBR Engineering Works</title>
        <meta
          name="description"
          content="Learn about UBR Engineering Works – a leading engineering machinery manufacturer in India with expert leadership and experienced teams."
        />
        <meta
          name="keywords"
          content="About UBR Engineering, engineering company India, industrial machinery team, chairman, managing director"
        />
        <meta name="author" content="UBR Engineering Works" />
      </Helmet>

      <h2 id="about-heading" className="about-title">About Us</h2>
      <div className="underline" aria-hidden="true"></div>

      <div className="about-text-wrapper">
        <p>
          Established in <strong>1993</strong>, UBR Engineering Works is a trusted name in the field of wire and cable machinery manufacturing. With decades of experience and technical excellence, we specialize in designing and producing high-performance machines required for the manufacturing of wires and cables.
        </p>
        <p>
          Our commitment to engineering innovation and quality has positioned us as a reliable partner for clients across diverse segments of the cable industry.
        </p>
        <p>
          We are also actively engaged in developing <strong>Special Purpose Machines (SPMs)</strong> tailored to the unique needs of wire and cable production processes. Each machine is built using premium-grade raw materials and precision-driven technologies, ensuring durability, efficiency, and compliance with international standards.
        </p>
        <p>
          Our operations are powered by a dedicated team of skilled professionals who work in perfect harmony to maintain stringent quality control, timely delivery, and excellent customer service. With a strong infrastructure and customer-centric approach, we are committed to delivering solutions that enhance productivity and offer long-term value.
        </p>
        <p>
          Under the insightful leadership of our mentor, <strong>Mr. Udai Singh (Director)</strong>, we have earned a strong reputation in the industry. His deep knowledge and strategic vision have played a pivotal role in expanding our footprint and gaining the trust of a growing client base.
        </p>
      </div>

      <div className="card-container" role="group" aria-label="Team Members">
        {teamData.map((member, index) => (
          <motion.div
            key={index}
            className="about-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{
              y: -10,
              scale: 1.03,
              boxShadow: '0 12px 30px rgba(0, 0, 0, 0.15)',
            }}
            transition={{ type: 'spring', stiffness: 300, damping: 20 }}
            viewport={{ once: true }}
            aria-label={`${member.title}: ${member.name} - ${member.description}`}
          >
            <img
              src={member.image}
              alt={`${member.name} - ${member.title}`}
              className="card-image"
              loading="lazy"
            />
            <h3 className="card-title">{member.name}</h3>
            <p className="card-role">{member.title}</p>
            <p className="card-description">{member.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default AboutUs;
